export default __webpack_public_path__ + "static/jeremy hakes-7e0d74071a430fe1fb8e2aba8f41ad07.webp";